import { render, staticRenderFns } from "./DefaultParameter.vue?vue&type=template&id=3c9b2546&scoped=true"
import script from "./DefaultParameter.vue?vue&type=script&lang=js"
export * from "./DefaultParameter.vue?vue&type=script&lang=js"
import style0 from "./DefaultParameter.vue?vue&type=style&index=0&id=3c9b2546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b2546",
  null
  
)

export default component.exports